import axios from "../api";

export const listEmailTemplateAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/email-templates`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const publishEmailTemplate = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/email-templates/publish`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getEmailTemplateDetailsById = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/email-templates/detail/${id}`)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateEmailTemplate = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/email-templates/update`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
